// @flow
import type { Emit } from '../../core/events';

import * as r from 'ramda';
import { select } from 'redux-most';
import * as most from 'most';
import * as mA from 'most-adjunct';
import * as mostc from '../../crosscutting/mostc';

import * as signals from '../signals';
import * as messages from '../../domain/messages';
import { useAsyncHooks } from '../../domain/selectors';

const emitEpic = (emit: Emit) => (actions$, store) => r.pipe(
  select(signals.EMIT),
  mostc.map((action) => {
    const {
      payload: {
        hook,
        payload,
        allowAsync,
      },
    } = action;

    const asyncHooks = r.or(
      r.and(
        allowAsync,
        useAsyncHooks(store.getState()),
      ),
      false,
    );

    const emit$ = mA.fromEagerPromise(() => emit(
      hook,
      payload,
      asyncHooks,
    ));

    return r.pipe(
      mostc.map(
        r.always(
          messages.emitSuccess(hook, payload),
        ),
      ),
      mostc.recoverWith(
        r.always(
          most.of(
            messages.emitFailed(hook, payload),
          ),
        ),
      ),
    )(emit$);
  }),
  most.join,
)(actions$);

export default emitEpic;
